import { render, staticRenderFns } from "./ModalBankData.vue?vue&type=template&id=52048d98"
import script from "./ModalBankData.vue?vue&type=script&lang=js"
export * from "./ModalBankData.vue?vue&type=script&lang=js"
import style0 from "./ModalBankData.vue?vue&type=style&index=0&id=52048d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports